import React from 'react';
import { Grid, GridProps } from '@mui/material';

export const Row = React.forwardRef<HTMLDivElement, GridProps>((props, ref) => {
  return <Grid ref={ref} container {...props} />;
});

Row.displayName = 'Row';
